module.exports = __webpack_public_path__ + "static/VC_2-0e6c416b032fa581e52c5ce83765c1bd.png";